import lawyerConnectionThunk from './lawyer-connection';
import prematterThunk from './prematter';
import fileThunk from './file';

export default {
  lawyerConnectionThunk,
  prematterThunk,
  fileThunk,
};
